(() => {
  function initialize(bar) {
    if (bar.dataset.initialized === 'true') return;
    const sectionId = bar.dataset.novaStickySection;
    const info = document.querySelector(`product-info[data-section="${CSS.escape(sectionId || '')}"]`);
    if (!info) return;
    bar.dataset.initialized = 'true';
    document.body.appendChild(bar);
    const price = bar.querySelector('[data-nova-sticky-price]');
    const trigger = bar.querySelector('.nova-sticky-atc__button');
    let scheduled = false;

    function mainButton() { return info.querySelector('.product-form__submit'); }
    function overlayOpen() {
      return !!document.querySelector('header-drawer details[open], .nova-modal.is-open, cart-drawer.active, details-modal details[open]');
    }
    function currentPrice() {
      const wrap = info.querySelector('[id^="price-"] .price');
      if (!wrap || wrap.closest('.hidden')) return '';
      const selector = wrap.classList.contains('price--on-sale')
        ? '.price__sale .price-item--sale'
        : '.price__regular .price-item--regular';
      return wrap.querySelector(selector)?.textContent.trim() || '';
    }
    function blocked(button) {
      const variant = info.querySelector('product-form input[name="id"]');
      return !button || button.disabled || button.getAttribute('aria-disabled') === 'true' ||
        button.classList.contains('loading') || !variant?.value || variant.disabled;
    }
    function update() {
      scheduled = false;
      if (!info.isConnected) {
        bar.remove();
        infoObserver.disconnect();
        bodyObserver.disconnect();
        document.body.classList.remove('nova-sticky-atc-open');
        return;
      }
      const button = mainButton();
      const anchor = info.querySelector('.product-form__buttons');
      const visible = !!anchor && anchor.getBoundingClientRect().bottom < 0 && !overlayOpen();
      bar.classList.toggle('is-visible', visible);
      document.body.classList.toggle('nova-sticky-atc-open', visible && matchMedia('(max-width: 749px)').matches);
      if (price) {
        const value = currentPrice();
        if (price.textContent.trim() !== value) price.textContent = value;
      }
      if (trigger) {
        trigger.disabled = blocked(button);
        trigger.setAttribute('aria-disabled', String(trigger.disabled));
        const text = button?.querySelector('span')?.textContent.trim() || button?.textContent.trim();
        if (text && trigger.textContent.trim() !== text) trigger.textContent = text;
      }
    }
    function schedule() {
      if (scheduled || !info.isConnected) return;
      scheduled = true;
      requestAnimationFrame(update);
    }
    const infoObserver = new MutationObserver(schedule);
    // Observe the stable product-info root: Dawn replaces the inner price node.
    infoObserver.observe(info, { childList: true, subtree: true, characterData: true,
      attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'aria-busy', 'class'] });
    const bodyObserver = new MutationObserver(schedule);
    bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    const cart = document.querySelector('cart-drawer');
    if (cart) bodyObserver.observe(cart, { attributes: true, attributeFilter: ['class'] });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data.sectionId !== sectionId) return;
        info.querySelectorAll('[data-nova-product-facts]').forEach(destination => {
          const source = data.html.getElementById(destination.id);
          if (source) destination.innerHTML = source.innerHTML;
        });
        schedule();
      });
    }
    document.addEventListener('toggle', schedule, true);
    document.addEventListener('nova:modal-state', schedule);
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);

    trigger?.addEventListener('click', event => {
      const button = mainButton();
      if (blocked(button) || overlayOpen()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      if (trigger.hasAttribute('data-nova-sticky-submit')) {
        event.preventDefault();
        // Use the original button so loading, variant and cart state share one path.
        button.click();
      }
    });
    update();
  }
  const initializeAll = () => document.querySelectorAll('[data-nova-sticky-atc]').forEach(initialize);
  initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
})();
